import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { openRewardsGrid, resetRewardsGrid, closeRoulette } from '../../actions/actions';
import RewardGrid from '../rewardGrid';
import Roulette from '../roulette';
import './style.scss';

export class RouletteApp extends React.Component {
  openRewardGrid() {
    this.props.openRewardsGrid();
    this.props.resetRewardsGrid();
    this.props.closeRoulette();
  }

  render() {
    let buttonClassNames = classNames(
      'btn',
      'open-reward-grid',
      { 'is-hidden': this.props.roulette.isRouletteShown }
    );

    let wrapperClassNames = classNames(
      'roulette-wrapper',
      { 'auto-height': this.props.roulette.isRouletteShown || this.props.roulette.isModalShown }
    );

    let logoClassNames = classNames(
      'roulette-logo',
      { 'small': this.props.roulette.isRouletteShown || this.props.roulette.isModalShown }
    );

    let titleClassNames = classNames(
      { 'is-hidden': this.props.roulette.isRouletteShown }
    );

    return (
      <div className={wrapperClassNames}>
        <div className="roulette-header">
          <div className={logoClassNames}>
            <img className="roulette-logo-icon" src="/images/logo-icon.svg" />
            <img className="roulette-logo-text" src="/images/logo-text.svg" />
          </div>
          <h1 className={titleClassNames}>Choose 3 rewards and give it a spin!</h1>
        </div>
        <div className="roulette-content">
          {
            this.props.roulette.isRouletteShown ? (<Roulette rewards={this.props.rewards}/>) : ''
          }
        </div>
        {
          this.props.roulette.isModalShown ? (<RewardGrid/>) : ''
        }
        <div className="roulette-footer">
          <button className={buttonClassNames} onClick={this.openRewardGrid.bind(this)}>Gimme the money!</button>
        </div>
      </div>
    );
  }
}


RouletteApp.propTypes = {
  openRewardsGrid: React.PropTypes.func,
  closeRoulette: React.PropTypes.func,
  resetRewardsGrid: React.PropTypes.func,
  roulette: React.PropTypes.object,
  rewards: React.PropTypes.array
};

const mapStateToProps = (state) => ({
  roulette: state.roulette,
  rewards: state.rewards
});

export default connect(mapStateToProps, { openRewardsGrid, resetRewardsGrid, closeRoulette })(RouletteApp);



/** WEBPACK FOOTER **
 ** ./src/components/rouletteApp/index.js
 **/